<div class="container-fluid d-flex flex-column h-100 py-3">
  <div class="row">
    <div class="col">
      <h2 class="fw-semibold">{{ title }}</h2>
    </div>
  </div>
  <div class="row flex-grow-1">
    <div class="col">
      <app-ap-configs-grid
        [suppliedQueryData]="suppliedQueryData"
        [gridName]="'AdminApConfigs'"
      ></app-ap-configs-grid>
    </div>
  </div>
</div>
